import $ from 'jquery';
import SelectedJobsState from './SelectedJobsState';
import WorkBasket from './WorkBasket';
import BasketIndicator from './BasketIndicator';
import QuoteService from './QuoteService';
import MobileFooter from './MobileFooter';
import WorkCta from './WorkCta';
import QuoteMessage from './QuoteMessage';
import EventBus from '../../common/EventBus';

const SELECTORS = {
  basket: '.js-basket',
  removeWorkBtn: '.js-remove-work-btn',
  removeWorkItemBtn: '.js-remove-work-item-btn',
  addWorkItemBtn: '.js-add-work-item-btn',
  workPageContent: '.work-page-content',
  moreInfoModal: '#work-item-more-info-modal',
  categoryModal: '.top-level-category-modal',
  workItem: '.js-work-item',
  searchResults: '.search-results',
  popularRepairs: '.popular-repairs-container',
  repairCategoryTree: '.repair-category-tree',
  workSection: '.js-work-section',
  v2MoreInfoFooter: '.v2-more-info-modal-footer',
};

// Helper to safely track analytics events
const trackAnalytics = (event, properties) => {
  if (typeof _kmq !== 'undefined') {
    _kmq.push(['record', event, properties]);
  }
};

export default class WorkPage {
  constructor() {
    this.selectedJobsState = new SelectedJobsState();
    this.workBasket = new WorkBasket();
    this.basketIndicator = new BasketIndicator();
    this.mobileFooter = new MobileFooter();
    this.workCta = new WorkCta();
    this.quoteMessage = new QuoteMessage();
    this.quoteService = new QuoteService(this.selectedJobsState);
    this._subscribeToQuoteEvents();
    this.init();
  }

  init() {
    this.workBasket.clearWorkItems();
    this.selectedJobsState.selectedJobs().forEach((job) => {
      this.workBasket.add(job.work_item_id, job.description);
    });

    // Setup remove button handler - call through _handleRemoveWorkButtonClick to ensure consistency
    const self = this;
    $(SELECTORS.basket).on('click', SELECTORS.removeWorkBtn, function (e) {
      self._handleRemoveWorkButtonClick(e);
    });

    $(`${SELECTORS.workPageContent}, ${SELECTORS.moreInfoModal}, ${SELECTORS.categoryModal}`)
      .off('click', SELECTORS.addWorkItemBtn)
      .on('click', SELECTORS.addWorkItemBtn, (e) => this._handleAddWorkItemButtonClick(e));
  }

  _subscribeToQuoteEvents() {
    EventBus.on('quote:updated', (data) => {
      this.onQuoteUpdate(data.quote);
    });
    EventBus.on('quote:error', () => {
      this.onQuoteError();
    });
  }

  addJob(id, description, section) {
    this.selectedJobsState.add(id, description);

    // Track the item being added
    const props = {
      id: id,
      description: description,
      booking_id: typeof bookingId !== 'undefined' ? bookingId : null,
      path: window.location.pathname,
    };
    if (section) {
      props['section'] = section;
    }
    trackAnalytics('Selected Work Item', props);

    this.updateButtonStates();
  }

  removeJob(id, shouldUpdateQuote = true) {
    this.selectedJobsState.remove(id);

    $(`.js-add-work-item-btn[data-id="${id}"]`).removeClass('added').trigger('item_removed');
    $(`${SELECTORS.workItem}[data-id="${id}"]`).trigger('item_removed');

    if (shouldUpdateQuote) {
      this.quoteService.debouncedGetQuote();
    }
  }

  updateButtonStates() {
    this.selectedJobsState.ids().forEach((selectedId) => {
      const $btn = $(`.js-add-work-item-btn[data-id="${selectedId}"]`);
      if ($btn.length) {
        $btn.addClass('added').trigger('item_added');
      }
    });
  }

  onQuoteUpdate(data) {
    this.workBasket.updateQuote(data);
    this._removeUnquotedItems(data);
    if (!data.quote_items) {
      this.selectedJobsState.clear();
      $(SELECTORS.workPageContent).find('.js-add-work-item-btn.added').removeClass('added').trigger('item_removed');
    }
  }

  onQuoteError() {
    const lastAddedJob = this.selectedJobsState.lastAddedJob();
    if (lastAddedJob) {
      this.removeJob(lastAddedJob.work_item_id);
    } else {
      this.workBasket.updateQuote({ total_price: '0.00' });
    }
    window.Application.display_modal($('#update-quote-error-modal'));
  }

  _handleRemoveWorkButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const removeButton = $(e.currentTarget);
    const id = removeButton.parents(SELECTORS.workItem).data('id');
    if (typeof id !== 'undefined') {
      this.removeJob(id);
    }
  }

  _handleAddWorkItemButtonClick(e) {
    const job = $(e.currentTarget);
    const id = parseInt(job.attr('data-id'), 10);
    const description = job.attr('data-work-description');

    this._removeFocus(e, job);

    // If the work item already exists, remove it
    if (job.hasClass('added')) {
      this._unselectWorkItem(id, description);
    } else {
      this._selectWorkItem(id, description, this._getSection(job));
    }
  }

  _removeFocus(e, job) {
    if (e.screenX > 0 || e.screenY > 0) {
      job.trigger('blur');
    }
  }

  _unselectWorkItem(id, description) {
    this.removeJob(id);
    trackAnalytics('Unselected Work Item', {
      id: id,
      description: description,
      booking_id: typeof bookingId !== 'undefined' ? bookingId : null,
      path: window.location.pathname,
    });
  }

  _selectWorkItem(id, description, section) {
    this.handleSingleChoiceItems(id);
    this.addJob(id, description, section);
    this.quoteService.debouncedGetQuote();
  }

  handleSingleChoiceItems(addedId) {
    window.Application.SINGLE_CHOICE_ITEMS.forEach((group) => {
      if (group.includes(parseInt(addedId))) {
        this.selectedJobsState
          .selectedJobs()
          .filter((job) => group.includes(parseInt(job.work_item_id)))
          .forEach((job) => this.removeJob(job.work_item_id));
      }
    });
  }

  _getSection(job) {
    let section = 'unknown';
    const sectionObj = job.parents(SELECTORS.workSection)[0];
    if (sectionObj) {
      section = sectionObj.getAttribute('data-work-type');
    } else if (this._hasParent(job, SELECTORS.searchResults)) {
      section = 'search';
    } else if (this._hasParent(job, SELECTORS.v2MoreInfoFooter)) {
      section = 'moreInfo';
    }

    let subSection = '';
    if (this._hasParent(job, SELECTORS.popularRepairs)) {
      subSection = '.popular';
    } else if (this._hasParent(job, SELECTORS.repairCategoryTree)) {
      subSection = '.categories';
    }

    return section.concat(subSection);
  }

  _hasParent(element, selector) {
    return element.parents(selector).length > 0;
  }

  _removeUnquotedItems(data) {
    // If we can give a partial quote, loop through the failed items
    // and remove them from the quote
    const items = data.unquoted_items || [];
    Object.keys(items).forEach((itemId) => {
      this.removeJob(itemId, false);
    });
  }
}
